module.exports = __webpack_public_path__ + "static/media/Team.900a5822.svg";